module.exports = __webpack_public_path__ + "static/img/69a408c.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/sendPoints/pic3.png
// module id = 688
// module chunks = 2